import './style.scss';
import React from 'react';
import { Component } from 'react';
require('dotenv').config();


class PageUnavailabe extends Component{

  render(){
    return (   
      <div className="medium-container">
        <h1 className="margin-top-xx-large tds-h1--small">We&rsquo;re sorry.</h1>
        <p className="margin-top-xx-large tds-large">We could not find the page you are looking for. The address may have expired or is incorrect.</p>
        <hr className="content-divider margin-top-xx-large shorten-divider" />
        <p className="margin-top-xx-large tds-heading">We&rsquo;ve recorded the error to see if there is something we can improve.</p>       
        <p className="tds-heading">If the problem persists, please contact the {process.env.REACT_APP_RMIS_CALL_US_CONTACT}  at <a href={'tel:+' + process.env.REACT_APP_RMIS_CALL_US_NUM}>{process.env.REACT_APP_RMIS_CALL_US_NUM}</a>.</p>
      </div>
    );  
  } 
}
export default PageUnavailabe;
